/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_SubmitInputs */

const en_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const ar_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأكيد`)
};

const de_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

const es_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const fr_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer`)
};

const it_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma`)
};

const ja_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認`)
};

const ko_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인`)
};

const pt_br_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const ru_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить`)
};

const th_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยัน`)
};

const tr_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onayla`)
};

const zh_cn_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认`)
};

const zh_tw_btn_submit = /** @type {(inputs: Btn_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Btn_SubmitInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_submit = /** @type {((inputs?: Btn_SubmitInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_SubmitInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_submit(inputs)
	if (locale === "ar") return ar_btn_submit(inputs)
	if (locale === "de") return de_btn_submit(inputs)
	if (locale === "es") return es_btn_submit(inputs)
	if (locale === "fr") return fr_btn_submit(inputs)
	if (locale === "it") return it_btn_submit(inputs)
	if (locale === "ja") return ja_btn_submit(inputs)
	if (locale === "ko") return ko_btn_submit(inputs)
	if (locale === "pt_br") return pt_br_btn_submit(inputs)
	if (locale === "ru") return ru_btn_submit(inputs)
	if (locale === "th") return th_btn_submit(inputs)
	if (locale === "tr") return tr_btn_submit(inputs)
	if (locale === "zh_cn") return zh_cn_btn_submit(inputs)
	return zh_tw_btn_submit(inputs)
});